import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgModule } from '@angular/core';
import { RxIconModule } from './../rx-icon/rx-icon.module';
import { RxSnackbarComponent } from './rx-snackbar.component';
import { RxIconComponent } from '../rx-icon/rx-icon.component';

@NgModule({
  imports: [CommonModule, RxIconModule, MatProgressBarModule, RxSnackbarComponent, RxIconComponent],
  exports: [RxSnackbarComponent],
})
export class RxSnackbarModule {}
